import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CameraPreview } from '@ionic-native/camera-preview/ngx';
import { Base64Service, UiBsUtilModule } from '@wlp/ui-bs-util';
import { IonicModule } from '@ionic/angular';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCHeaderModule } from '@wlp/ui-c-header';
import { CommonModule } from '@angular/common';

let UiCCameraComponent = class UiCCameraComponent {
    constructor(cameraPreview, base64Service) {
        this.cameraPreview = cameraPreview;
        this.base64Service = base64Service;
        this.prospera = false;
        this.sizeFile = 5242880;
        this.photo = new EventEmitter();
        this.burst = new EventEmitter();
        this.goBack = new EventEmitter();
        this.pictureOpts = {
            width: window.screen.width,
            height: window.screen.height,
            quality: 85,
        };
    }
    buildPreviewOption() {
        return {
            x: 0,
            y: 0,
            width: window.screen.width,
            height: window.screen.height,
            camera: this.selfieCamera ? 'front' : 'rear',
            tapPhoto: false,
            previewDrag: true,
            toBack: true,
            alpha: 1,
        };
    }
    ngAfterContentInit() {
        this.picture = null;
        this.startCamera();
    }
    startCamera() {
        this.cameraPreview
            .startCamera(this.buildPreviewOption())
            .then((res) => {
        })
            .catch((err) => {
            //console.error('StartCamera start', err);
            this.stopCamera();
        });
    }
    takePicture() {
        this.cameraPreview
            .takeSnapshot(this.pictureOpts)
            .then((pictureData) => {
            pictureData.forEach((picture) => {
                this.picture = 'data:image/jpeg;base64,' + picture;
                //console.log(this.picture);
            });
            this.stopCamera();
        })
            .catch((err) => {
            console.error('takePicture Error', err);
        });
    }
    stopCamera() {
        this.cameraPreview
            .stopCamera()
            .then((res) => {
            // console.log('stopCamera', res);
        })
            .catch((err) => {
            // console.error('stopCamera Error', err);
        });
    }
    switchCamera() {
        this.cameraPreview
            .switchCamera()
            .then((res) => {
            //console.log('switchCamera', res);
        })
            .catch((err) => {
            // console.error('switchCamera Error', err);
        });
    }
    goBackCamera() {
        this.picture = '';
        this.startCamera();
    }
    onGoBack() {
        this.picture = '';
        this.stopCamera();
        this.goBack.emit();
    }
    confirm() {
        const blob = this.base64Service.b64toBlob(this.picture);
        if (blob.size > this.sizeFile) {
            this.burst.emit();
            return;
        }
        this.photo.emit({ photo: this.picture });
        this.onGoBack();
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCCameraComponent.prototype, "typePhoto", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCCameraComponent.prototype, "titleHeader", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCCameraComponent.prototype, "typeQuestion", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCCameraComponent.prototype, "selfieCamera", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCCameraComponent.prototype, "prospera", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], UiCCameraComponent.prototype, "sizeFile", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCCameraComponent.prototype, "photo", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCCameraComponent.prototype, "burst", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCCameraComponent.prototype, "goBack", void 0);
UiCCameraComponent = __decorate([
    Component({
        selector: 'ui-c-camera',
        template: "<div [class]=\"'camera ' + typePhoto\" [ngClass]=\"{ preview: picture }\">\n  <ui-c-header\n    *ngIf=\"!prospera\"\n    [mode]=\"'text'\"\n    (goBack)=\"onGoBack()\"\n    imagePath=\"assets/images/brand/brand-log-bank.svg\"\n    altText=\"LogBank\"\n  >\n    <ng-container *ngIf=\"!picture\">{{ titleHeader }}</ng-container>\n    <ng-container *ngIf=\"picture\">{{ typeQuestion }}</ng-container>\n  </ui-c-header>\n\n  <ui-c-header\n    *ngIf=\"prospera\"\n    [mode]=\"'text'\"\n    (goBack)=\"onGoBack()\"\n    [backgroundImage]=\"'/assets/images/prospera/header01.svg'\"\n    [type]=\"'logon'\">\n    <ng-container *ngIf=\"!picture\">{{ titleHeader }}</ng-container>\n    <ng-container *ngIf=\"picture\">{{ typeQuestion }}</ng-container>\n  </ui-c-header>\n\n  <div class=\"template-photo ion-text-center\" *ngIf=\"!picture\">\n    <ng-container *ngIf=\"typePhoto === 'template'\">\n      <img class=\"type-template\" src=\"assets/images/functions/camera/template.svg\" alt=\"\" />\n    </ng-container>\n\n    <ng-container *ngIf=\"typePhoto === 'selfie'\">\n      <img class=\"type-self\" src=\"assets/images/functions/camera/selfie-2.svg\" alt=\"\" />\n    </ng-container>\n\n    <ng-container *ngIf=\"typePhoto === 'doc'\">\n      <img class=\"type-doc\" src=\"assets/images/functions/camera/doc-open.svg\" alt=\"\" />\n    </ng-container>\n  </div>\n\n  <ion-content class=\"ion-content ion-no-padding ion-text-center\">\n    <ng-container *ngIf=\"!picture\">\n      <ion-fab-button class=\"ion-fab-button container-camera-button\" (click)=\"takePicture()\">\n        <ion-icon class=\"ion-icon\" name=\"camera\"></ion-icon>\n      </ion-fab-button>\n    </ng-container>\n\n    <ng-container *ngIf=\"picture\">\n      <img class=\"img-preview\" [src]=\"picture\" alt=\"Image of the camera\" />\n      <ion-row class=\"ion-row container-button w100\">\n        <ion-col class=\"ion-col\">\n          <ui-c-button expand=\"block\" (continue)=\"goBackCamera()\">N\u00E3o</ui-c-button>\n        </ion-col>\n        <ion-col class=\"ion-col\">\n          <ui-c-button expand=\"block\" (continue)=\"confirm()\">Sim</ui-c-button>\n        </ion-col>\n      </ion-row>\n    </ng-container>\n  </ion-content>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [CameraPreview, Base64Service])
], UiCCameraComponent);

let UiCCameraModule = class UiCCameraModule {
};
UiCCameraModule = __decorate([
    NgModule({
        declarations: [UiCCameraComponent],
        imports: [
            IonicModule,
            CommonModule,
            UiCButtonModule,
            UiCHeaderModule,
            UiBsUtilModule
        ],
        exports: [UiCCameraComponent],
        providers: [CameraPreview],
    })
], UiCCameraModule);

export { UiCCameraComponent, UiCCameraModule };
//# sourceMappingURL=wlp-ui-c-camera.js.map
